// extracted by mini-css-extract-plugin
module.exports = {"header":"fixed-logo-top-bar_header__mdJsg","logoContainer":"fixed-logo-top-bar_logoContainer__8Ldk8"};